import React from 'react';
import * as MDICONS from '@material-ui/icons';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';

const ErrorComponent = () => {
    return (
        <div>
            <MDICONS.ErrorOutline style={{ scale: "2" }} />
            <h3><div className="mt-3 mb-1">404: Page not found</div></h3>
            <Link to={ROUTES.LANDING}>Go back</Link>
        </div>
    )
}

export default ErrorComponent
